import {Project} from '../model/Project';
import {v4 as uuidv4} from 'uuid';
export const aviapiratesApp: Project = {
  id: uuidv4(),
  label: 'Aviapirates',
  description: 'More info coming soon...',
};
